import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import { Toaster } from "react-hot-toast";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import store from "./store/index";
import ChatProvider from "./context/chat";
import "./index.css";
import "./App.css";
import { AgentChatProvider } from "./context/AgentChatContext";

const App = lazy(() => import("./App"));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
        <BrowserRouter>
            <ChatProvider>
                <AgentChatProvider>
                    <Toaster
                        toastOptions={{
                            position: "top-right",
                            style: {
                                background: "#283046",
                                color: "white"
                            }
                        }}
                    />
                    <App />
                </AgentChatProvider>
            </ChatProvider>
        </BrowserRouter>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
